module.exports = __webpack_public_path__ + "img/img_shouye_waihui@2x.57f9c2b0.png";